import * as React from 'react';
import { GlobalContactForm as GlobalContactForm$1 } from '@grandvisionhq/content';
import { useFeatureToggles } from '@grandvisionhq/state';
import { compose } from '@grandvisionhq/utils';
import CmsHeadTags from '../HeadTags/HeadTags.js';
import { withBloomreachData } from '../../hocs/with-bloomreach-data.js';

const CmsGlobalContactForm = ({ meta  })=>{
    const { country , brand , locale  } = meta;
    const { featureConfigs  } = useFeatureToggles();
    const { globalContactFormUrl  } = featureConfigs;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CmsHeadTags, null, /*#__PURE__*/ React.createElement("link", {
        rel: "stylesheet",
        href: `${globalContactFormUrl}/styles.css`
    })), /*#__PURE__*/ React.createElement(GlobalContactForm$1, {
        country: country,
        brand: brand,
        locale: locale
    }));
};
var GlobalContactForm = compose(withBloomreachData)(CmsGlobalContactForm);

export { GlobalContactForm as default };
//# sourceMappingURL=GlobalContactForm.js.map
